import axios from "./api";
class BranchService {
  getAll() {
    return axios.get(`/branches`);
  }
  getPublicAll() {
    return axios.get(`/public/branches`);
  }
  get(id) {
    return axios.get(`/branches/${id}`);
  }
  create(data) {
    return axios.post(`/branches`, data);
  }
  createBranchTraining(data) {
    return axios.post(`/branche_training_programs`, data);
  }
  update(id, data) {
    return axios.put(`/branches/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/branches/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new BranchService();
